export default "__VITE_ASSET__D_In21xm__"